import { HotelFilterForm } from '@pages/travel/hotel/data-models';
import { Tag } from '@shared/models/tag';
import { IRoomGroupOrder } from '@shared/shared/interfaces/site-settings.interfaces';
import { MappedHotelSearchResult } from './search/mapped-hotel-search-result';

export interface HotelResult {
  attribute_ids: number[];
  instalment_payments_available: boolean;
  product_id: number;
  product_name: string;
  rating: string;
  location: {
    longitude: string;
    latitude: string;
  };
  sub_title: string;
  image: Image;
  from_price: {
    amount: string;
    currency_code: string;
  };
  amenities: number[];
  is_benefits_hotel: boolean;
  deposit_required: boolean;
  booking_token: string;
  benefit_rate_code: string;
  rooms: HotelRoom[];
  title: string;
  sort_priority?: number;
  is_recommended?: boolean;
  is_preferred?: boolean;
  tags: Tag[];
}

export interface Image {
  source: string;
  description: string;
}

export interface HotelRoom {
  instalment_payments_available: boolean;
  product_code: string;
  benefit_rate_code?: string;
  room_type: string;
  booking_token: string;
  price_per_night: {
    amount: number;
    currency_code: string;
  };
  total_price: {
    amount: number;
    currency_code: string;
  };
  is_non_refundable: boolean;
  supplier: string;
  meal_basis: number;
  benefit_rate_description: string[];
  special_offers: string[];
  on_request_dc_rooms: boolean;
  pay_local_required: boolean;
  room_group?: number;
  seq: number;
  adyen_instalments_allowed?: boolean;
}

export enum HotelRoomPriceOrdering {
  ASCENDING = 1,
  DESCENDING = 2,
  RECOMMENDED = 3,
}

export interface HotelRoomWithKey {
  key: {
    roomCategory: RoomCategory;
    nonRefundable: boolean;
    payLocalRequired: boolean;
    onRequestDCRooms: boolean;
    payByInstalments: boolean;
    roomType: string;
    productCode: string;
    roomGroup: IRoomGroupOrder;
    productGroupForBanner: string;
    supplier?: string;
  };
  meals: MealBasis[];
}

export interface MealBasis {
  id: number;
  roomGroup?: number;
  price: Price;
  hotelRoom: HotelRoom;
  productCode?: string;
  specialOffers?: string[];
  benefitRateDescription?: string[];
}

export type Price = {
  amount: number;
  currencyCode: string;
};

export enum RoomCategory {
  nonDC = 1,
  DC = 2,
  AmadeusHotels = 3,
  Instalments = 4,
}

export interface HotelResultRoomsForSorting extends HotelRoom {
  _sort_priority: number;
}

export interface HotelSearchResponse {
  search_reference_id: string;
  results: HotelResult[];
  travel_hotels_rooms_price_per_night: boolean;
  room_requests?: number;
  mappedSortedHotels?: MappedHotelSearchResult[];
  defaultFilters?: HotelFilterForm;
}

export interface BannerData {
  text: string;
  productGroup: string;
}
